// Rota bazli SEO meta verisi.
// Bu modul saf JS'tir (JSX/React yok) — hem build sonrasi calisan Node scripti
// (scripts/prerender.mjs) hem de React tarafi tarafindan import edilebilir.
// Basliklar/aciklamalar src/i18n.jsx icindeki TR "seo" bloguyla ayni tutulmalidir;
// i18n.jsx bir JSX dosyasi oldugu icin Node'dan import edilemez, bu yuzden TR
// metinler burada bilerek tekrarlanmistir (TR sitenin varsayilan dilidir).

import {
    breadcrumbJsonLd as buildBreadcrumbJsonLd,
    organizationJsonLd,
    personJsonLd,
    serviceJsonLd,
    websiteJsonLd,
} from "./jsonld.js";

export const SITE_URL = "https://kochanproductions.com";
export const SITE_NAME = "Kochan Productions";
export const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const socialServiceJsonLd = serviceJsonLd({
    name: "Social Media Management",
    description: "Profesyonel sosyal medya yonetimi, icerik stratejisi ve dijital pazarlama hizmetleri",
    path: "/social-media",
});

const webServiceJsonLd = serviceJsonLd({
    name: "Web Development",
    description: "Kurumsal web sitesi tasarimi, gelistirme ve bakim hizmetleri",
    path: "/web-services",
});

/** Ana Sayfa -> hedef sayfa seklinde iki adimli breadcrumb uretir (TR isimlerle). */
export function breadcrumbJsonLd(name, path) {
    return buildBreadcrumbJsonLd([
        { name: "Ana Sayfa", path: "/" },
        { name, path },
    ]);
}

export const staticRoutes = [
    {
        path: "/",
        title: "Kochan Productions | Video Prodüksiyon & Sosyal Medya | Yalova",
        description:
            "Yalova merkezli profesyonel video prodüksiyon, fotoğraf ve sosyal medya yönetimi. Kurumsal tanıtım filmi, reklam videosu ve drone çekimiyle markanızı öne çıkarın.",
        ogType: "website",
        jsonLd: [organizationJsonLd(), websiteJsonLd()],
    },
    {
        path: "/work",
        title: "Fotoğraflarımız | Kochan Productions",
        description:
            "Ürün, etkinlik, portre ve mimari fotoğrafçılık alanlarında profesyonel çalışmalarımızı görüntüleyin. Kochan Productions fotoğraf portföyü.",
        ogType: "website",
        jsonLd: [breadcrumbJsonLd("Fotoğraflar", "/work")],
    },
    {
        path: "/about",
        title: "Hakkımızda | Kochan Productions - Mücahit Koçhan",
        description:
            "Kochan Productions, yılların deneyimiyle video, fotoğrafçılık ve sosyal medya alanında hizmet vermektedir. Kurucumuz Mücahit Koçhan hakkında bilgi edinin.",
        ogType: "website",
        jsonLd: [personJsonLd(), breadcrumbJsonLd("Hakkımızda", "/about")],
    },
    {
        path: "/contact",
        title: "İletişim | Kochan Productions - Yalova",
        description:
            "Kochan Productions ile iletişime geçin. Profesyonel video prodüksiyon, fotoğraf çekimi ve sosyal medya hizmetleri için bize ulaşın. Yalova, Türkiye.",
        ogType: "website",
        jsonLd: [organizationJsonLd(), breadcrumbJsonLd("İletişim", "/contact")],
    },
    {
        path: "/social-media",
        title: "Sosyal Medya Yönetimi | Kochan Productions",
        description:
            "Profesyonel sosyal medya yönetimi hizmetleri. İçerik stratejisi, hesap yönetimi ve dijital pazarlama ile markanızın online varlığını güçlendirin.",
        ogType: "website",
        jsonLd: [socialServiceJsonLd, breadcrumbJsonLd("Sosyal Medya", "/social-media")],
    },
    {
        path: "/web-services",
        title: "Web Hizmetleri | Kochan Productions",
        description:
            "Yalova'daki işletmeler için kurumsal web sitesi tasarımı, geliştirme ve bakım hizmetleri sunuyoruz. Modern, hızlı, responsive ve SEO uyumlu web çözümleri.",
        ogType: "website",
        jsonLd: [webServiceJsonLd, breadcrumbJsonLd("Web Hizmetleri", "/web-services")],
    },
];

export const notFoundMeta = {
    title: "Sayfa Bulunamadı | Kochan Productions",
    description:
        "Aradığınız sayfa bulunamadı. Kochan Productions ana sayfasından video prodüksiyon, fotoğraf ve sosyal medya hizmetlerimize ulaşabilirsiniz.",
    robots: "noindex, nofollow",
};
